import {Directive, ElementRef, Input} from '@angular/core';

@Directive({
   selector: '[background-image]'
})
export class BackgroundDirective {
   private el: HTMLElement;

   constructor(el: ElementRef) {
       this.el = el.nativeElement;
   }

   @Input('background-image') backgroundImage: string;
   @Input('background-height') height:string

   ngAfterViewInit() {
       this.el.style.backgroundImage = 'url(' + this.backgroundImage + ')';
       this.el.style.height = this.height; //this.el.style.minHeight = this.height;
   }

}
// <div class="header" background-image="{{ item.featured_image }}">



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/shared/background/background.directive.ts